"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bannerDetail = bannerDetail;
exports.clone = clone;
exports.deleteBanner = deleteBanner;
exports.deleteDiamondCategory = deleteDiamondCategory;
exports.deletePage = deletePage;
exports.deleteSort = deleteSort;
exports.diamondCategoryList = diamondCategoryList;
exports.fullList = fullList;
exports.getDiamondCategoryList = getDiamondCategoryList;
exports.getLink = getLink;
exports.getList = getList;
exports.getModuleList = getModuleList;
exports.moduleDetail = moduleDetail;
exports.queryComponent = queryComponent;
exports.querySubComponent = querySubComponent;
exports.queryTabBarDetail = queryTabBarDetail;
exports.queryTabBarList = queryTabBarList;
exports.saveModules = saveModules;
exports.saveOrUpdate = saveOrUpdate;
exports.saveOrUpdateBanner = saveOrUpdateBanner;
exports.saveOrUpdateCategory = saveOrUpdateCategory;
exports.updateColor = updateColor;
exports.updateSort = updateSort;
exports.updateStatus = updateStatus;
exports.updateTabBar = updateTabBar;
exports.updateTopInfo = updateTopInfo;
var _request = _interopRequireDefault(require("@/utils/request"));
function getList(params) {
  return (0, _request.default)({
    url: "/portal/system/decorate/page/list",
    method: "get",
    params: params
  });
}
function saveOrUpdate(data) {
  return (0, _request.default)({
    url: "/portal/system/decorate/page/saveOrUpdate",
    method: "post",
    data: data
  });
}
function deletePage(data) {
  return (0, _request.default)({
    url: "/portal/system/decorate/page/delete",
    method: "post",
    data: data
  });
}
function getLink(params) {
  return (0, _request.default)({
    url: "/portal/system/decorate/page/getLink",
    method: "get",
    params: params
  });
}
function getModuleList(params) {
  return (0, _request.default)({
    url: "/portal/system/decorate/module/list",
    method: "get",
    params: params
  });
}
function updateColor(data) {
  return (0, _request.default)({
    url: "/portal/system/decorate/page/updateColor",
    method: "post",
    data: data
  });
}
function updateStatus(data) {
  return (0, _request.default)({
    url: "/portal/system/decorate/module/updateStatus",
    method: "post",
    data: data
  });
}
function updateSort(data) {
  return (0, _request.default)({
    url: "/portal/system/decorate/module/updateSort",
    method: "post",
    data: data
  });
}
function deleteSort(data) {
  return (0, _request.default)({
    url: "/portal/system/decorate/module/delete",
    method: "post",
    data: data
  });
}
function queryComponent(params) {
  return (0, _request.default)({
    url: "/portal/system/decorate/module/queryComponent",
    method: "get",
    params: params
  });
}
function querySubComponent(params) {
  return (0, _request.default)({
    url: "/portal/system/decorate/module/querySubComponent",
    method: "get",
    params: params
  });
}
function saveModules(data) {
  return (0, _request.default)({
    url: "/portal/system/decorate/module/save",
    method: "post",
    data: data
  });
}
function moduleDetail(params) {
  return (0, _request.default)({
    url: "/portal/system/decorate/module/detail/list",
    method: "get",
    params: params
  });
}
function bannerDetail(params) {
  return (0, _request.default)({
    url: "/portal/system/decorate/module/detail/detail",
    method: "get",
    params: params
  });
}
function saveOrUpdateBanner(data) {
  return (0, _request.default)({
    url: "/portal/system/decorate/module/detail/saveOrUpdate",
    method: "post",
    data: data
  });
}
function deleteBanner(data) {
  return (0, _request.default)({
    url: "/portal/system/decorate/module/detail/delete",
    method: "post",
    data: data
  });
}
function fullList(params) {
  return (0, _request.default)({
    url: "/portal/system/decorate/module/activity/fullList",
    method: "get",
    params: params
  });
}
function clone(data) {
  return (0, _request.default)({
    url: "/portal/system/homepage/template/clone",
    method: "post",
    data: data
  });
}
function getDiamondCategoryList(params) {
  return (0, _request.default)({
    url: "/portal/system/decorate/module/detail/getDiamondCategoryList",
    method: "get",
    params: params
  });
}
function deleteDiamondCategory(data) {
  return (0, _request.default)({
    url: "/portal/system/decorate/module/detail/deleteDiamondCategory",
    method: "post",
    data: data
  });
}
function diamondCategoryList(params) {
  return (0, _request.default)({
    url: "/portal/system/decorate/module/detail/diamondCategoryList",
    method: "get",
    params: params
  });
}
function saveOrUpdateCategory(data) {
  return (0, _request.default)({
    url: "/portal/system/decorate/module/detail/saveOrUpdateCategory",
    method: "post",
    data: data
  });
}
function updateTopInfo(data) {
  return (0, _request.default)({
    url: "/portal/system/decorate/page/updateTopInfo",
    method: "post",
    data: data
  });
}
function queryTabBarList(params) {
  return (0, _request.default)({
    url: "/portal/system/decorate/navbar/list",
    method: "get",
    params: params
  });
}
function queryTabBarDetail(params) {
  return (0, _request.default)({
    url: "/portal/system/decorate/navbar/detail",
    method: "get",
    params: params
  });
}
function updateTabBar(data) {
  return (0, _request.default)({
    url: "/portal/system/decorate/navbar/update",
    method: "post",
    data: data
  });
}